import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { BehaviorSubject, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import { OptionWindow } from 'src/app/enum/option-window-enums';
import { OrderStateEnums, OrderTypeEnums } from 'src/app/enum/order-enums';
import { ProfileUserEnums } from 'src/app/enum/profile-user-enums';
import { ActionColor, CheckBoxAction, TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { CostCenterPriceModel } from 'src/app/models/archive/cost-center-price.model';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { OrderDetailModel } from 'src/app/models/preliminaries/order-detail.model';
import { OrderModel } from 'src/app/models/preliminaries/order.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { ArticleSelectionTableModel } from 'src/app/models/tables/archive/article-selection-table.model';
import { OrderDetailCaptureTableModel } from 'src/app/models/tables/preliminaries/order-detail-capture-table.model';
import { OrderDetailService } from 'src/app/services/preliminaries/order-detail.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { RegisterCostCenterPriceComponent } from 'src/app/views/archive/cost-center-price/register-cost-center-price/register-cost-center-price.component';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { OrderFromQuotationStepperComponent } from '../../order-from-quotation/order-from-quotation-stepper/order-from-quotation-stepper.component';
import { OrderPriceComponent } from '../../order-price/order-price/order-price.component';
import { ImportOrderDetailComponent } from '../import-order-detail/import-order-detail.component';
import { UpdateCompromiseDateComponent } from '../update-compromise-date/update-compromise-date.component';

@Component({
  selector: 'app-order-detail',
  templateUrl: './order-detail.component.html',
  styleUrls: ['./order-detail.component.scss'],
  standalone: false
})
export class OrderDetailComponent implements OnInit {

  @ViewChild('articleForOrderSelection') articleSelectionModalComponent?: CustomModalComponent | null = null;
  @ViewChild('costCenterPriceRegisterModal') costCenterPriceRegisterComponent?: CustomModalComponent | null = null;
  @ViewChild('compromiseDate') compromiseDateModalComponent?: CustomModalComponent | null = null;
  @ViewChild('orderFromQuotation') orderFromQuotationModalComponent?: CustomModalComponent | null = null;
  @ViewChild('orderDetailImportModal') orderDetailImportModalComponent?: CustomModalComponent | null = null;
  @ViewChild('orderPriceModal') orderPriceModalComponent?: CustomModalComponent | null = null;

  @Input() disableAllDetail: boolean = false;
  @Input() disablePartial: boolean = false;
  @Input() disableOrderFromQuotation: boolean = false;
  @Input() permissionsUser: OptionWindowModel[] = [];
  @Input() permissionUpdatable: boolean = false;
  @Input() userAuthenticated: UserModel = new UserModel();
  @Input() orderModel: OrderModel = new OrderModel();
  @Input() isCreatingOrderFromQuotation: boolean = false;
  @Input() swQuotation: boolean = false;
  @Input() swMandatoryQuotation: boolean = false;
  @Input() swReservation: boolean = false;
  @Input() swShowOnlyOrderBreakdown: boolean = false;
  @Output() emitQuantityDetails = new EventEmitter<number>();
  @Output() orderId = new EventEmitter<number>();

  ascendant: boolean = true;
  ascendantArticle: boolean = true;
  checkboxActions: CheckBoxAction[] = [
    {
      label: 'Eliminar',
      icon: 'pi pi-trash',
      color: ActionColor.DANGER,
      action: 'bulk-delete'
    },
  ];
  clearSelectionTrigger: number = 0;
  columnSort: string | null = null;
  columnSortArticle: string | null = null;
  componentOrderPriceModal = OrderPriceComponent;
  componentTableSelection = CustomTableSelectComponent;
  componentRegisterModal = RegisterCostCenterPriceComponent;
  componentOrderDetailImportModal = ImportOrderDetailComponent;
  componentUpdateCompromiseDateModal = UpdateCompromiseDateComponent;
  componentOrderFromQuotationStepper = OrderFromQuotationStepperComponent;
  costCenterPriceContract: CostCenterPriceModel = new CostCenterPriceModel();
  dataArticle: PagedResponseModel<ArticleSelectionTableModel> = new PagedResponseModel<ArticleSelectionTableModel>();
  detailData: PagedResponseModel<OrderDetailCaptureTableModel> = new PagedResponseModel<OrderDetailCaptureTableModel>();
  detailHeader: ColumnResponseModel[] = [];
  filtersArticle: ColumnResponseModel[] = [];
  headerArticle: ColumnResponseModel[] = [];
  inputsForArticlesSelection$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    showCheckbox: false,
    showRecover: true,
    isMultipleSelect: true,
    filters: [],
    actions: []
  });
  inputsForPriceOrderModals$ = new BehaviorSubject<any>({
    orderDetail: 0,
    costCenterId: 0,
    disable: this.disablePartial
  });
  inputsForcompromiseDateModals$ = new BehaviorSubject<any>({
    orderId: 0
  });
  inputsForOrderDetailImportModals$ = new BehaviorSubject<any>({
    orderId: 0,
    orderTypeId: 0
  });
  inputsForOrderFromQuotationModals$ = new BehaviorSubject<any>({
    orderModel: 0,
    swMandatoryQuotation: this.swMandatoryQuotation,
    swShowOnlyOrderBreakdown: this.swShowOnlyOrderBreakdown
  });
  inputsForRegisterModals$ = new BehaviorSubject<any>({
    blockForm: false,
    costCenterPriceModel: new CostCenterPriceModel(),
    openFrom: ''
  });
  isFormView: boolean = false;
  limit: number = 10;
  limitArticle: number = 5;
  openFromCostCenterPrice: string = '';
  orderDetail: OrderDetailModel = new OrderDetailModel();
  orderDetails: OrderDetailModel[] = [];
  output$ = new Subject<any>();
  page: number = 1;
  pageArticle: number = 1;
  quantityDetails: number = 0;
  subscription: Subscription;
  tableActions: TableAction[] = [];

  constructor(private confirmDialogService: ConfirmDialogService,
    private orderDetailService: OrderDetailService,
    private toastHandlerService: ToastHandlerService) { }

  async ngOnInit() {
    this.tableActions = this.getDefaultActions();
    await this.getColumnsForDetailCaptureAsync();
    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChangeArticle(payload);
          break;
        case 'onFilterChange':
          this.onFilterChange(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  async ngOnChanges(changes: SimpleChanges) {
    const orderModel = changes["orderModel"];
    const disableAllDetail = changes["disableAllDetail"];
    const isCreatingOrderFromQuotation = changes["isCreatingOrderFromQuotation"];
    if (disableAllDetail && !disableAllDetail.firstChange) {
      this.tableActions = this.disableAllDetail ? [] : this.getDefaultActions();
    }
    if (orderModel && !orderModel.firstChange) {
      this.clearSelectionTrigger++;
      await this.getOrderDetailsForCaptureTable();
    }
    if (isCreatingOrderFromQuotation && !isCreatingOrderFromQuotation.firstChange) {
      this.openOrderFromQuotationModal();
    }
  }

  async deleteOrderDetail(selectedIds: number[]) {
    if (selectedIds.length > 0) {
      const selectedDetails = this.detailData.items.filter(x => selectedIds.includes(x.orderDetailId));
      const hasRemission = selectedDetails.some(x => x.quantityRemission > 0);
      if (hasRemission) {
        return this.toastHandlerService.showToast(
          'error',
          'No es posible eliminar. Uno o más artículos están asociados a remisiones.'
        );
      }
      const invalidOrigin = selectedDetails.some(x => x.isOrderAdjustment);
      if (invalidOrigin) {
        return this.toastHandlerService.showToast(
          'error',
          'No es posible eliminar. Uno o más artículos fueron creados por logística.'
        );
      }
      const accepted = await this.confirmDialogService.confirm('¿Realmente desea eliminar los detalles seleccionados?');
      if (accepted) {
        try {
          await firstValueFrom(this.orderDetailService.deleteSomeDetails(selectedIds, false));
          this.toastHandlerService.showToast(
            'success',
            'Los detalles fueron eliminados exitosamente.'
          );
          this.clearSelectionTrigger++;
          await this.getOrderDetailsForCaptureTable();
        } catch (error) {
          console.error('Error al eliminar el detalle del pedido.', error);
        }
      }
    }
  }

  async editOrderDetail(id: number) {
    this.orderDetail = await this.getOrderDetailById(id);
    this.getFormView(true);
  }

  async getArticlesForDetails() {
    try {
      this.dataArticle = await firstValueFrom(
        this.orderDetailService.getArticlesForDetails(
          this.pageArticle, this.limitArticle, this.columnSortArticle, this.ascendantArticle, this.filtersArticle, this.orderModel.orderId
        )
      );
      this.updateInputs();
    } catch (error) {
      console.error('Error al obtener la lista de los artículos', error);
    }
  }

  async getColumnsArticles() {
    try {
      this.headerArticle = await firstValueFrom(this.orderDetailService.getColumnsForArticles(this.orderModel.orderId));
      this.updateInputs();
    } catch (error) {
      console.error('Error al buscar las columnas para la selección de artículos.', error);
    }
  }

  async getColumnsForDetailCaptureAsync() {
    try {
      this.detailHeader = await firstValueFrom(this.orderDetailService.getColumnsForDetailCaptureAsync());
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta.', error);
    }
  }

  async getCostCenterPriceRegister(costCenterPrice: CostCenterPriceModel) {
    if (costCenterPrice.costCenterPriceId > 0) {
      if (this.openFromCostCenterPrice === "createOrderDetail" || this.openFromCostCenterPrice === "editOrderDetail") {
        this.costCenterPriceContract = costCenterPrice;
        await this.getOrderDetailsForCaptureTable();
      }
    }
  }

  getCostCenterPriceOpen(costCenterPrice: CostCenterPriceModel) {
    this.openFromCostCenterPrice = 'createOrderDetail';
    this.costCenterPriceContract = costCenterPrice;
    this.openCostCenterPriceRegisterModal();
  }

  getDefaultActions(): TableAction[] {
    return [
      {
        label: 'Editar',
        icon: 'pi pi-pencil',
        action: 'edit'
      },
      {
        label: 'Editar Precios C.Costos',
        icon: 'pi pi-dollar',
        action: 'prices-cost-center',
      },
    ];
  }

  getFormView(isFormView: boolean) {
    this.isFormView = isFormView;
  }

  async getOrderDetailByKeys(articleId: number): Promise<OrderDetailModel> {
    try {
      return await firstValueFrom(this.orderDetailService.getOrderDetailByKeys(this.orderModel.orderId, articleId));
    } catch (error) {
      console.error('Error al obtener el detalle del pedido.', error);
      return new OrderDetailModel();
    }
  }

  async getOrderDetailById(orderDetailId: number): Promise<OrderDetailModel> {
    try {
      return await firstValueFrom(this.orderDetailService.getOrderDetailById(orderDetailId));
    } catch (error) {
      console.error('Error al obtener el detalle por id.', error);
      return new OrderDetailModel();
    }
  }

  async getOrderDetailsForCaptureTable() {
    try {
      this.detailData = await firstValueFrom(
        this.orderDetailService.getOrderDetailsForCaptureTable(
          this.page, this.limit, this.columnSort, this.ascendant, this.orderModel.orderId
        )
      );
      this.getFormView(false);
      this.quantityDetails = this.detailData.totalItems;
      this.emitQuantityDetails.emit(this.quantityDetails);
    } catch (error) {
      console.error('Error al buscar los detalles del pedido.', error);
    }
  }

  async handleCostCenterPriceModal(orderDetailId: number) {
    try {
      const orderDetail = await this.getOrderDetailById(orderDetailId);
      const isNotRentalOrder = (this.orderModel.orderTypeId !== OrderTypeEnums.rental);
      const isGenericArticle = orderDetail.article?.swGeneric;
      if (orderDetail.quotationId && orderDetail.quotationId !== 0) {
        this.toastHandlerService.showToast(
          'error',
          'No es posible modificar, el artículo viene de una cotización.'
        );
        return;
      }
      if (isGenericArticle || isNotRentalOrder) {
        this.openOrderPriceModal(orderDetail);
        return;
      }
      if (orderDetail.costCenterPrice) {
        this.orderDetail = orderDetail;
        this.openCostCenterPriceModal(orderDetail.costCenterPrice);
      }
    } catch (error) {
      console.error('Error al preparar la información de precios (centro de costos o pedido).', error);
    }
  }

  async handleSelectedItem(selectedItem: any) {
    if (selectedItem.length == 1) {
      const [{ articleId, rentalUnitId }] = selectedItem;
      const response = await this.getOrderDetailByKeys(articleId);
      if (response.orderDetailId === 0) {
        response.rentalUnitId = rentalUnitId;
        this.orderDetail = response;
      } else {
        this.orderDetail = response;
      }
    } else {
      const newDetails = selectedItem.map((element: {
        orderId: number,
        articleId: number,
        rentalUnitId: number
      }) => {
        const newOrderDetail = new OrderDetailModel();
        newOrderDetail.isOrderAdjustment = false;
        newOrderDetail.orderId = this.orderModel.orderId;
        newOrderDetail.articleId = element.articleId;
        newOrderDetail.rentalUnitId = element.rentalUnitId;
        return newOrderDetail;
      });
      this.orderDetails = newDetails;
    }
  }

  async onAction(event: { action: string, item?: OrderDetailCaptureTableModel, selectedItems?: number[] }) {
    switch (event.action) {
      case 'edit':
        await this.editOrderDetail(event.item!.id);
        break;
      case 'prices-cost-center':
        await this.handleCostCenterPriceModal(event.item!.id);
        break;
      case 'bulk-delete':
        if (event.selectedItems) {
          await this.deleteOrderDetail(event.selectedItems);
        }
        break;
    }
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters.map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index).map((item: any) => item.value);
    this.filtersArticle = this.removeDuplicates(filters);
    this.filtersArticle.forEach((filter: any) => this.processFilter(filter));
    this.updateInputs();
  }

  async openArticleSelectionModal() {
    this.filtersArticle = [];
    await Promise.all([
      this.getColumnsArticles(),
      this.getArticlesForDetails()
    ]);
    this.updateInputs();
    this.articleSelectionModalComponent?.show();
  }

  openCostCenterPriceModal(data: any): void {
    this.costCenterPriceContract = new CostCenterPriceModel();
    this.openFromCostCenterPrice = "editOrderDetail";
    this.costCenterPriceContract.articleId = data.articleId;
    this.costCenterPriceContract.costCenterId = data.costCenterId;
    this.costCenterPriceContract.conceptInvoicingId = data.conceptInvoicingId;
    this.openCostCenterPriceRegisterModal();
  }

  async openOrderPriceModal(orderDetail: OrderDetailModel) {
    if (!this.orderModel.orderId && this.orderModel.orderId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear un pedido.'
      );
      return;
    }
    this.inputsForPriceOrderModals$.next({
      orderDetail: orderDetail,
      costCenterId: this.orderModel.costCenterId,
      disable: this.disablePartial
    });
    this.orderPriceModalComponent?.show();
  }

  openOrderFromQuotationModal() {
    this.inputsForOrderFromQuotationModals$.next({
      swMandatoryQuotation: this.swMandatoryQuotation,
      swShowOnlyOrderBreakdown: this.swShowOnlyOrderBreakdown,
      orderModel: this.orderModel
    });
    this.orderFromQuotationModalComponent?.show();
  }

  openCostCenterPriceRegisterModal() {
    this.inputsForRegisterModals$.next({
      costCenterPriceModel: this.costCenterPriceContract,
      openFrom: this.openFromCostCenterPrice,
      blockForm: this.disablePartial,
    });
    this.costCenterPriceRegisterComponent?.show();
  }

  openCompromiseDateModal() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        'El usuario no tiene permisos para cambiar las fechas de compromiso del pedido.\nComuníquese con el administrador del sistema.'
      );
      return;
    }
    if (this.orderModel.orderId === 0) {
      this.toastHandlerService.showToast(
        'warning',
        'El pedido aún no se ha guardado.'
      );
      return;
    }
    if (this.orderModel.orderStateId !== OrderStateEnums.open) {
      this.toastHandlerService.showToast(
        'warning',
        'El pedido debe estar en estado "Abierto".'
      );
      return;
    }
    this.inputsForcompromiseDateModals$.next({
      orderId: this.orderModel.orderId
    });
    this.compromiseDateModalComponent?.show();
  }

  openOrderDetailImportModal() {
    const isAdminWithImportPermission = this.userAuthenticated.profileUser.code === ProfileUserEnums.administrador &&
      this.permissionsUser.some(x => x.code === OptionWindow.Importar);
    if (this.quantityDetails > 0) {
      this.toastHandlerService.showToast(
        'warning',
        `No se puede importar si el pedido ya tiene detalle.`
      );
      return;
    }
    if (isAdminWithImportPermission) {
      this.toastHandlerService.showToast(
        'warning',
        `El usuario no tiene permisos para importar detalles de un pedido, comuniquese con el administrador del sistema.`
      );
      return;
    }
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        `El usuario no tiene permisos para la edición de Pedidos. Comuníquese con el administrador del sistema.`
      );
      return;
    }
    if (this.orderModel.orderId === 0) {
      this.toastHandlerService.showToast(
        'warning',
        `El pedido aún no se ha guardado.`
      );
      return;
    }
    if (this.orderModel.orderStateId !== OrderStateEnums.open) {
      this.toastHandlerService.showToast(
        'warning',
        'El pedido debe estar en estado "Abierto".'
      );
      return;
    }
    this.inputsForOrderDetailImportModals$.next({
      orderTypeId: this.orderModel.orderTypeId,
      orderId: this.orderModel.orderId,
    });
    this.orderDetailImportModalComponent?.show();
  }

  async onPageChangeArticle(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.pageArticle = event.page;
    this.limitArticle = event.pageSize;
    this.columnSortArticle = event.sortField || null;
    this.ascendantArticle = event.sortOrder === 1;
    await this.getArticlesForDetails();
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    await this.getOrderDetailsForCaptureTable();
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filtersArticle = this.filtersArticle.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filtersArticle.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  async reload(reload: any) {
    if (reload) {
      await this.getOrderDetailsForCaptureTable();
    }
  }

  async reloadHeaderAndDetail(event: any) {
    if (event.orderId) {
      this.orderId.emit(event.orderId);
    } else if (event.reloadDetail) {
      await this.getOrderDetailsForCaptureTable();
    }
  }

  updateInputs() {
    this.inputsForArticlesSelection$.next({
      headers: this.headerArticle,
      data: this.dataArticle,
      showCheckbox: true,
      showRecover: true,
      isMultipleSelect: true,
      limitPaginator: true,
      filters: this.filtersArticle,
      actions: [
        {
          label: 'Imágenes',
          icon: 'pi pi-image',
          action: 'view-image'
        }
      ]
    });
  }
}
